import { Container, ContainerProps } from '@everlywell/ui-kit';
import React from 'react';

export interface SectionContainerProps extends ContainerProps {
  children?: React.ReactNode | React.ReactNode[];
  useDefaultMargin?: boolean;
}

/**
 * A container for sections of a page.
 * It has the basic styling for what a section container should look like. Fluid width on mobile and xl width (1440px) on desktop.
 * If useDefaultMargin is true, it will have a default vertical margin. 20px on mobile and 40px on desktop.
 * Values passing different values for chakra ui props.
 * @param {SectionContainerProps} props - The props for the component.
 */
const SectionContainer = React.forwardRef<
  HTMLDivElement,
  SectionContainerProps
>(({ children, useDefaultMargin = false, ...rest }, ref) => (
  <Container
    as="section"
    ref={ref}
    size={['fluid', null, 'xl']}
    margin={useDefaultMargin ? [5, null, '10'] : undefined}
    marginX="auto"
    {...rest}
  >
    {children}
  </Container>
));

export default SectionContainer;
